(function () {
  try {
    var root = document.querySelector('[data-section-type="product"]') || document.getElementById('mp-main');
    if (!root) return;

    var stickyBar = root.querySelector('[data-mp-sticky-bar]');
    var formActions = root.querySelector('.mp__form-actions');
    var footerEl = document.querySelector('footer, #shopify-section-footer, .footer, .shopify-section--footer, #footer');

    /* Check if screen is mobile view */
    function isMobileScreen() {
      return window.matchMedia('(max-width: 640px)').matches;
    }

    /* ── ELASTIC CLICK ANIMATION FEEDBACK TRIGGER ── */
    function triggerClickFeedback(btn) {
      if (!btn) return;
      btn.classList.remove('is-clicked');
      void btn.offsetWidth; // Force CSS animation restart
      btn.classList.add('is-clicked');
      setTimeout(function() {
        btn.classList.remove('is-clicked');
      }, 350);
    }

    /* Global listener for main product page buttons */
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-mp-add-to-cart], [data-mp-buy-now], .mp__btn--atc, .mp__btn--buy');
      if (btn) {
        triggerClickFeedback(btn);
      }
    }, true);

    /* ── FAST SINGLE-TAP BINDING FOR IOS SAFARI (IPHONE FIX) ── */
    function bindFastTap(btn, callback) {
      if (!btn) return;
      btn.style.touchAction = 'manipulation';

      var handled = false;

      btn.addEventListener('touchend', function(e) {
        handled = true;
        e.preventDefault();
        e.stopPropagation();
        triggerClickFeedback(btn);
        callback(e);
        setTimeout(function() { handled = false; }, 300);
      }, { passive: false });

      btn.addEventListener('click', function(e) {
        if (handled) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
        e.preventDefault();
        triggerClickFeedback(btn);
        callback(e);
      });
    }

    /* ── SCROLL LISTENER WITH AUTOMATIC FOOTER HIDE (MOBILE ONLY) ── */
    function updateStickyVisibility() {
      if (!stickyBar || !formActions) return;

      /* Hide sticky bar on desktop/laptop view */
      if (!isMobileScreen()) {
        stickyBar.classList.remove('is-visible');
        return;
      }

      var formRect = formActions.getBoundingClientRect();
      var isFormPassed = formRect.bottom < 0;

      var isFooterVisible = false;
      if (footerEl) {
        var footerRect = footerEl.getBoundingClientRect();
        if (footerRect.top <= (window.innerHeight || document.documentElement.clientHeight)) {
          isFooterVisible = true;
        }
      }

      /* Show Sticky Bar ONLY on mobile when form is passed AND footer is NOT visible */
      if (isFormPassed && !isFooterVisible) {
        stickyBar.classList.add('is-visible');
      } else {
        stickyBar.classList.remove('is-visible');
      }
    }

    window.addEventListener('scroll', updateStickyVisibility, { passive: true });
    window.addEventListener('resize', updateStickyVisibility, { passive: true });
    document.addEventListener('DOMContentLoaded', updateStickyVisibility);
    updateStickyVisibility();

    /* DROPDOWN 1: OPTION 1 */
    var opt1Wrap = root.querySelector('[data-mp-sticky-opt1-wrap]');
    var opt1Trigger = root.querySelector('[data-mp-sticky-opt1-trigger]');
    var opt1Title = root.querySelector('[data-mp-sticky-opt1-title]');
    var opt1Options = root.querySelectorAll('[data-mp-sticky-opt1-val]');

    /* DROPDOWN 2: OPTION 2 / SINGLE DROPDOWN */
    var stickyVariantWrap = root.querySelector('[data-mp-sticky-variant-wrap]');
    var stickyVariantTrigger = root.querySelector('[data-mp-sticky-variant-trigger]');
    var stickyVariantTriggerTitle = root.querySelector('[data-mp-sticky-variant-trigger-title]');
    var stickyVariantTriggerBadge = root.querySelector('[data-mp-sticky-variant-trigger-badge]');
    var stickyVariantOptions = root.querySelectorAll('[data-mp-sticky-variant-option]');

    function closeAllPanels() {
      if (opt1Wrap) {
        opt1Wrap.classList.remove('is-open');
        if (opt1Trigger) opt1Trigger.setAttribute('aria-expanded', 'false');
      }
      if (stickyVariantWrap) {
        stickyVariantWrap.classList.remove('is-open');
        if (stickyVariantTrigger) stickyVariantTrigger.setAttribute('aria-expanded', 'false');
      }
    }

    if (opt1Trigger) {
      bindFastTap(opt1Trigger, function() {
        var isOpen = opt1Wrap.classList.contains('is-open');
        closeAllPanels();
        if (!isOpen) {
          opt1Wrap.classList.add('is-open');
          opt1Trigger.setAttribute('aria-expanded', 'true');
        }
      });
    }

    if (stickyVariantTrigger) {
      bindFastTap(stickyVariantTrigger, function() {
        var isOpen = stickyVariantWrap.classList.contains('is-open');
        closeAllPanels();
        if (!isOpen) {
          stickyVariantWrap.classList.add('is-open');
          stickyVariantTrigger.setAttribute('aria-expanded', 'true');
        }
      });
    }

    document.addEventListener('click', function(e){
      if ((!opt1Wrap || !opt1Wrap.contains(e.target)) && (!stickyVariantWrap || !stickyVariantWrap.contains(e.target))) {
        closeAllPanels();
      }
    });

    /* CLICK HANDLER FOR OPTION 1 STICKY DROPDOWN */
    opt1Options.forEach(function(opt){
      bindFastTap(opt, function() {
        var val = opt.dataset.mpStickyOpt1Val;
        if (!val) return;

        var matchingPill = root.querySelector('[data-mp-option1-pill][data-option1-value="' + val + '"]');
        if (matchingPill) {
          matchingPill.click();
        }
        closeAllPanels();
      });
    });

    /* LISTEN FOR VARIANT CHANGED EVENT */
    document.addEventListener('mp:variant-changed', function(e){
      var card = e.detail ? e.detail.card : null;
      if (!card) return;

      var opt1Val = card.dataset.option1;
      var displayTitle = card.dataset.displayTitle || card.dataset.variantTitle;
      var badgeText = card.dataset.variantBadge;
      var badgeColor = card.dataset.variantBadgeColor;
      var id = card.dataset.variantId;

      /* Update Option 1 Title */
      if (opt1Title && opt1Val) {
        opt1Title.textContent = opt1Val;
      }
      opt1Options.forEach(function(opt){
        if (opt.dataset.mpStickyOpt1Val === opt1Val) opt.classList.add('is-selected');
        else opt.classList.remove('is-selected');
      });

      /* Update Option 2 Title */
      if (stickyVariantTriggerTitle && displayTitle) {
        stickyVariantTriggerTitle.textContent = displayTitle;
      }

      /* Update Option 2 Trigger Badge */
      if (stickyVariantTriggerBadge) {
        if (badgeText && badgeText.trim() !== '') {
          stickyVariantTriggerBadge.textContent = badgeText;
          stickyVariantTriggerBadge.style.backgroundColor = badgeColor || '#de5279';
          stickyVariantTriggerBadge.style.display = 'inline-flex';
        } else {
          stickyVariantTriggerBadge.textContent = '';
          stickyVariantTriggerBadge.style.display = 'none';
        }
      }

      /* Filter Option 2 Dropdown Options by Selected Option 1 */
      stickyVariantOptions.forEach(function(opt){
        var cardOpt1 = opt.dataset.option1;
        if (!opt1Val || !cardOpt1 || cardOpt1 === opt1Val) {
          opt.style.display = 'flex';
        } else {
          opt.style.display = 'none';
        }

        if (opt.dataset.variantId === id) {
          opt.classList.add('is-selected');
        } else {
          opt.classList.remove('is-selected');
        }
      });

      /* Update Prices & Image Thumb */
      var stickyPriceEl = root.querySelector('[data-mp-sticky-price]');
      var stickyCompareEl = root.querySelector('[data-mp-sticky-compare]');
      var stickySavingsEl = root.querySelector('[data-mp-sticky-savings]');
      var stickyThumbEl = root.querySelector('[data-mp-sticky-thumb]');

      var rawPrice = parseInt(card.dataset.variantPrice,10)||0;
      var rawCompare = card.dataset.variantComparePrice ? parseInt(card.dataset.variantComparePrice,10) : 0;
      var formatted = card.dataset.variantPriceFormatted || (rawPrice/100).toFixed(2);

      if (stickyPriceEl) stickyPriceEl.textContent = formatted;
      if (stickyCompareEl) {
        if (rawCompare > rawPrice && card.dataset.variantCompareFormatted) {
          stickyCompareEl.textContent = card.dataset.variantCompareFormatted;
          stickyCompareEl.style.display = '';
        } else {
          stickyCompareEl.style.display = 'none';
        }
      }
      if (stickySavingsEl) {
        if (rawCompare > rawPrice) {
          stickySavingsEl.textContent = 'Save ' + Math.round((rawCompare - rawPrice) * 100 / rawCompare) + '%';
          stickySavingsEl.style.display = '';
        } else {
          stickySavingsEl.style.display = 'none';
        }
      }
      var image = card.dataset.variantImage;
      if (stickyThumbEl && image) stickyThumbEl.src = image;
    });

    /* CLICK HANDLER FOR OPTION 2 / VARIANT DROPDOWN OPTIONS */
    stickyVariantOptions.forEach(function(opt){
      bindFastTap(opt, function() {
        if (opt.disabled || opt.classList.contains('is-unavailable')) return;

        var vId = opt.dataset.variantId;
        var matchingCard = root.querySelector('[data-mp-variant-card][data-variant-id="' + vId + '"]');
        if (matchingCard) {
          matchingCard.click();
        } else {
          var variantIdInput = root.querySelector('[data-mp-variant-id]');
          if (variantIdInput) variantIdInput.value = vId;
        }
        closeAllPanels();
      });
    });

    /* STICKY QUANTITY STEPPER HANDLER */
    var stickyQtyInput = root.querySelector('[data-mp-sticky-qty-input]');
    var stickyQtyMinus = root.querySelector('[data-mp-sticky-qty-minus]');
    var stickyQtyPlus = root.querySelector('[data-mp-sticky-qty-plus]');
    var mainQtyInput = root.querySelector('[data-mp-qty-input]');

    function syncStickyQuantity(val) {
      var v = parseInt(val, 10);
      if (isNaN(v) || v < 1) v = 1;
      if (stickyQtyInput) stickyQtyInput.value = v;
      if (mainQtyInput) {
        mainQtyInput.value = v;
        mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (stickyQtyInput) {
      if (stickyQtyMinus) {
        bindFastTap(stickyQtyMinus, function() {
          syncStickyQuantity((parseInt(stickyQtyInput.value, 10) || 1) - 1);
        });
      }
      if (stickyQtyPlus) {
        bindFastTap(stickyQtyPlus, function() {
          syncStickyQuantity((parseInt(stickyQtyInput.value, 10) || 1) + 1);
        });
      }
      stickyQtyInput.addEventListener('change', function(){
        syncStickyQuantity(stickyQtyInput.value);
      });
    }

    var stickyAddToCartBtn = root.querySelector('[data-mp-sticky-add-to-cart]');
    var stickyBuyBtn = root.querySelector('[data-mp-sticky-buy-now]');

    /* FAST 1-TAP ACTION FOR STICKY ADD TO CART */
    if (stickyAddToCartBtn) {
      bindFastTap(stickyAddToCartBtn, function() {
        var mainAtc = root.querySelector('[data-mp-add-to-cart]');
        if (mainAtc) mainAtc.click();
      });
    }

    /* DIRECT 1-TAP IPHONE BUY NOW CHECKOUT REDIRECT (NO DOUBLE CLICK) */
    if (stickyBuyBtn) {
      bindFastTap(stickyBuyBtn, function() {
        var variantInput = root.querySelector('[data-mp-variant-id]') || root.querySelector('input[name="id"]');
        var qtyInput = root.querySelector('[data-mp-sticky-qty-input]') || root.querySelector('[data-mp-qty-input]') || root.querySelector('input[name="quantity"]');

        var variantId = variantInput ? variantInput.value : '';
        var quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

        if (variantId) {
          /* Direct 1-Step Checkout Permalink (Instant 1-tap on iPhone) */
          window.location.href = '/cart/' + variantId + ':' + quantity;
        } else {
          var mainBuy = root.querySelector('[data-mp-buy-now]');
          if (mainBuy) mainBuy.click();
        }
      });
    }
  } catch(err){ console.error('mp-sticky script error:',err); }
})();